export const environment = {

  production: false,

  apiBase: '',

  clientId: '50acdd11-1485-47ef-8b81-0cbadcf1c385',

  authority: 'https://login.microsoftonline.com/d6204ca1-209d-46b4-ad1a-8b409cc03c93',

  graphEndpoint: 'https://graph.microsoft.com/v1.0/me'

};
